import { render, staticRenderFns } from "./companyDetail.vue?vue&type=template&id=e6720bc2&scoped=true"
import script from "./companyDetail.vue?vue&type=script&lang=js"
export * from "./companyDetail.vue?vue&type=script&lang=js"
import style0 from "./companyDetail.vue?vue&type=style&index=0&id=e6720bc2&prod&lang=scss&scoped=true"
import style1 from "./companyDetail.vue?vue&type=style&index=1&id=e6720bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6720bc2",
  null
  
)

export default component.exports